import React, { useEffect } from 'react';
import { Switch, Redirect } from 'react-router-dom';
import {
  Dashboard,
  CostEntry,
  Cost,
  Requests,
  Accounting,
  Reports,
  Help
} from './redux/container';
import RouteWithLayout from "./components/RouteWithLayout";
import { connectTo } from './redux/utils';
import { checkToken, removeSession } from "./redux/actions/login";

const Routes = (props) => {

  useEffect(() => {
    const { checkToken } = props;
    checkToken();
  }, [])

  return window.localStorage.getItem("auth") !== null ? (
    <Switch>
      <Redirect
        exact
        from="/"
        to="/panel"
      />
      <RouteWithLayout
        component={CostEntry}
        exact
        layout={Dashboard}
        path="/panel"
      />
      <RouteWithLayout
        component={Cost}
        exact
        layout={Dashboard}
        path="/cost"
      />
      <RouteWithLayout
        component={Requests}
        exact
        layout={Dashboard}
        path="/requests"
      />
      <RouteWithLayout
        component={Accounting}
        exact
        layout={Dashboard}
        path="/accounting"
      />
      <RouteWithLayout
        component={Reports}
        exact
        layout={Dashboard}
        path="/reports"
      />
      <RouteWithLayout
        component={Help}
        exact
        layout={Dashboard}
        path="/help"
      />

      <RouteWithLayout
        component={CostEntry}
        exact
        layout={Dashboard}
        path="*"
      />
    </Switch>
  ) : null
};

export default connectTo(() => (
  ({
    login: { auth }
  }) => ({
    auth
  })
), {
  removeSession,
  checkToken
}, Routes);

